// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-content[data-v-16f919a4]{margin-top:20px;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
